module.exports = __webpack_public_path__ + "images/services/google-drive-preview-logo.b6f802fba1fc1e0e9501.svg";